<script setup>
import BugReportModal from '~/components/UI/BugReportModal.vue'

const { bugReport } = useFeatureFlags()
const isOpen = ref(false)

const open = () => { isOpen.value = true }
const close = () => { isOpen.value = false }
</script>

<template>
  <div v-if="bugReport.enabled" class="flex flex-col items-center">
    <button
      v-tooltip.right="$t('bug_report.button_tooltip')"
      type="button"
      @click="open"
      class="flex items-center justify-center px-3 py-3 mt-2 cursor-pointer text-amber-900 bg-amber-200 hover:bg-amber-300 rounded-full transition-colors"
    >
      <Icon name="mdi:bug" class="text-xl" />
    </button>
    <BugReportModal v-if="isOpen" @close="close" />
  </div>
</template>
